import { NavLink } from 'react-router-dom';
import { Home, Wallet, Gift, Users, User } from 'lucide-react';
import { cn } from '../../lib/cn';

const tabs = [
  { to: '/home',      label: 'Home',    Icon: Home },
  { to: '/wallet',    label: 'Wallet',  Icon: Wallet },
  { to: '/bonus',     label: 'Bonus',   Icon: Gift },
  { to: '/hierarchy', label: 'Team',    Icon: Users },
  { to: '/profile',   label: 'Profile', Icon: User },
];

export function BottomNav() {
  return (
    <nav className="fixed bottom-0 left-0 right-0 max-w-md mx-auto bg-bg/95 backdrop-blur border-t border-border flex z-40 safe-b">
      {tabs.map(({ to, label, Icon }) => (
        <NavLink
          key={to}
          to={to}
          className={({ isActive }) =>
            cn(
              'flex-1 flex flex-col items-center justify-center gap-1 py-2.5 relative transition-colors',
              isActive ? 'text-accent' : 'text-fg-muted hover:text-fg',
            )
          }
        >
          {({ isActive }) => (
            <>
              {isActive && <span className="absolute top-1 h-1 w-1 rounded-full bg-accent" />}
              <Icon size={20} strokeWidth={2.2} />
              <span className="text-[10px] font-semibold tracking-wide uppercase">{label}</span>
            </>
          )}
        </NavLink>
      ))}
    </nav>
  );
}
